/* eslint-disable no-console */

/**
 * Utility function for consistent analysis logging
 * @param {string} message - The main log message
 * @param {Object} properties - Object containing key-value pairs to include in the log
 */
export const log = (message, properties = {}) => {
  const timestamp = new Date().toISOString().replace('T', ' ').replace('Z', '');
  const propertyStrings = Object.entries(properties).map(
    ([key, value]) => `${key}: ${value}`,
  );
  console.log(`[analysis ${timestamp}] ${message}`, ...propertyStrings);
};
